import { Achievements } from '~/features/stamps/achievements/types/enums';
import { StampType } from '~/features/stamps/interfaces/enums';

type AchievementPatterns = {
  [P in Achievements]: StampType[];
};

// アチーブメントのパターンを列挙する
// NOTE: 新しい組み合わせができたときはここに追加する
const achievementPatterns: AchievementPatterns = {
  [Achievements.FootMeasurement]: [StampType.FootMeasurement],
  [Achievements.FootMeasurementAndExtraBonus]: [StampType.FootMeasurement, StampType.ExtraBonus],
  [Achievements.CreateArtwork]: [StampType.CreateArtwork],
  [Achievements.PublishedGallery]: [StampType.PublishedGallery],
  [Achievements.CreateArtworkAndPublishedGallery]: [
    StampType.CreateArtwork,
    StampType.PublishedGallery,
  ],
  [Achievements.Birthday]: [StampType.Birthday],
  [Achievements.RegisterShoes]: [StampType.RegisterShoes],
};

// 配列の組み合わせを検索して条件に合う結果の値を返す
export const achievementFilter = (stampTypes: StampType[]) => {
  return (Object.keys(achievementPatterns) as Achievements[]).find((key) => {
    const stamp = stampTypes.filter((stamp) => stamp !== undefined);
    return JSON.stringify(stamp.sort()) === JSON.stringify(achievementPatterns[key].sort());
  });
};
